<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .background-tab {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    overflow: auto;
    padding-top: utils.in_rem(16px);

    .share-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 utils.in_rem(4px) 0 utils.in_rem(12px);
      border-radius: utils.in_rem(8px);
      background: colors.get(interfaceSwGrey_4);

      .resume-type {
        @include mixins.body2();
        @include colors.color(textDisabledGrey);
      }
    }
  }
</style>

<script>
  // Components
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import TabPanel from "@sourcewhale/shared/svelte-design-system/components/molecules/TabPanel.svelte";
  import Education from "./Education.svelte";
  import Experience from "./Experience.svelte";
  // Stores
  import { activePopUpModalStore } from "../../stores";

  const openShareResumeModal = () => {
    activePopUpModalStore.set({
      modal: "shareResume",
    });
  };

  const tabItems = [
    { label: "Experience", slot: "experienceTab", snippet: experienceSnippet },
    { label: "Education", slot: "educationTab", snippet: educationSnippet },
  ];
</script>

{#snippet experienceSnippet()}
  <Experience />
{/snippet}

{#snippet educationSnippet()}
  <Education />
{/snippet}

<div class="background-tab">
  <div class="share-header">
    <span class="resume-type">Linkedin Resume</span>
    <Button
      kind="ghost-blue"
      size="small"
      trailingIcon="fa-arrow-right"
      onclick={openShareResumeModal}>Share resume</Button
    >
  </div>
  <TabPanel type="secondary-pill" size="small" {tabItems} />
</div>
